import { hFetch } from './hFetch';

const basePath = '/api/custom_fields';

export const listCustomFields = async () => {
  return await hFetch({ url: basePath });
};

type CustomFieldEntity = 'contact:teammate';
export const listCustomFieldsForEntity = async ({ entity }: { entity: CustomFieldEntity }) => {
  return await hFetch({ url: `${basePath}?entity=${entity}` });
};

export const getCustomField = async ({ id }: { id: number }) => {
  return await hFetch({ url: `${basePath}/${id}` });
};

export const createCustomField = async ({ body }: { body: CustomField }) => {
  return await hFetch({
    url: basePath,
    method: 'POST',
    payload: {
      custom_field: body,
    },
  });
};

export const updateCustomField = async ({ id, body }: { id: number; body: CustomField }) => {
  return await hFetch({
    url: `${basePath}/${id}`,
    method: 'PATCH',
    payload: {
      custom_field: body,
    },
  });
};

export const deleteCustomField = async ({ id }: { id: number }) => {
  return await hFetch({ url: `${basePath}/${id}`, method: 'DELETE' });
};

type CustomField = {
  auto_collect_during_onboarding: boolean;
  created_at: string;
  field_type: string;
  id: number;
  key: string;
  name: string;
  options: string[];
  scopes: string[];
  sensitive: boolean;
  team_id: number;
  updated_at: string;
};
